import { render } from "./menuItem.vue?vue&type=template&id=4cb16b23&ts=true"
import script from "./menuItem.vue?vue&type=script&lang=ts"
export * from "./menuItem.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workpace\\yt-portal-layout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__